import React from 'react';
import { motion } from 'framer-motion';

const Story = () => {
  return (
    <section id="story" className="scroll-mt-24 bg-lotus-petal/20 px-6 py-20 lg:px-8 lg:py-28">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        className="mx-auto max-w-4xl text-center"
      >
        <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
          Our Story
        </span>
        <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
          A journey toward inner balance
        </h2>
        <div className="mt-8 space-y-6 text-lg leading-relaxed text-lotus-ink/70">
          <p>
            Modern life has become increasingly demanding. Whether at home or in the workplace, people often carry invisible burdens such as stress, emotional fatigue, mental exhaustion, and burnout.
          </p>
          <p>
            Lotus Prana was founded with a simple yet powerful purpose — to help individuals reconnect with their inner balance and experience a healthier, more fulfilling life. We believe that when individuals heal, families become stronger, workplaces become healthier, and communities flourish.
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default Story;
